import SvgChecklist from "@Components/CustomIcon/SvgChecklist"
import SvgStetoscope from "@Components/CustomIcon/SvgStetoscope"
import CardWithoutProgression from "@Components/CustomSimpleCard/CardWithoutProgression/CardWithoutProgression"
import CustomSimpleCard from "@Components/CustomSimpleCard/CustomSimpleCard"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { baseColors, baseFontFamily } from "@Constants/baseStyles"
import { allAxisAtom, currentDiagnosisAtom } from "@Recoil/Atom/DiagnosisAtom"
import { userAtom } from "@Recoil/Atom/userAtom"
import React, { useEffect, useState } from "react"
import { QuizzContext } from "@Providers/QuizzProvider"
import { useContext } from "react"
import { RefreshControl, ScrollView, View } from "react-native"
import { RFValue } from "react-native-responsive-fontsize"
import { useRecoilState, useSetRecoilState } from "recoil"
import styles from "./styles"
import { Spacer } from "@Components/Space"
import { DiagnosisState } from "@Constants/constant"
import { ActivityIndicator } from "react-native-paper"
import { useIsFocused } from "@react-navigation/native"
import { fetchAllAxis, fetchAllCategories, knowledges } from "./Logic"
import { DiagnosticEducatifContext } from "@Providers/DiagnosticEducatifProvider"
import { useUserPrograms } from "../../Hooks/useUserPrograms"
import CustomSimpleModal from "@Components/Modal/CustomSimpleModal/CustomSimpleModal"
import { Button } from "@Components/CustomButton/Button"
import { surveyResponsesAtom } from "@Recoil/Atom/surveyAtom"
import { LocalStorage } from "@Services/sharedPreferences/localStorage"
import { capitalizeFirstLetter } from "@Utils/utils"
import { useQueryDERQHooks } from "../../Hooks/ReactQueryHooks/useDERQHooks"
import * as Notifications from "expo-notifications"
import NewUpdatePopup from "./NewUpdatePopup"

const Home = (props) => {
    const [user, setUserData] = useRecoilState(userAtom)
    const { navigation } = props
    const isFocused = useIsFocused()
    const [openFollowUpModal, setOpenFollowUPModal] = useState(false)
    const [diagnosis, setDiagnosis] = useRecoilState(allAxisAtom)
    const [categories, setCategories] = useState([])
    const [loading, setLoading] = useState(false)
    const [planified, setPlanified] = useState(false)
    const { setSelectedKnowledge } = useContext(QuizzContext)
    const [currentEducationalDiagnosis, setCurrentEducationalDiagnosis] = useRecoilState(currentDiagnosisAtom)
    const { fetchingDiagEduc } = useContext(DiagnosticEducatifContext)

    const {
        fetchUserPrograms,
        disableMenu,
        fetchingUserPrograms,
        fetchPreselctedPatientProgram,
        fetchingPreselectedPatientProgram,
        hasProgramInProgress
    } = useUserPrograms()
    const setSurveyResponses = useSetRecoilState(surveyResponsesAtom)

    const { data, isLoading: fetchingDEFromRQ, refetch: refetchDE } = useQueryDERQHooks()

    function handleFetchData() {
        fetchUserPrograms()
        fetchPreselctedPatientProgram()
        // fetchEducationalDiagnosis({
        //     setLoading: setFetchingDiagEduc,
        //     user,
        //     setCurrentEducationalDiagnosis,
        //     isDiagnosticScreen: false,
        //     handleExpiredToken: handleExpireToken
        // })
    }

    useEffect(() => {
        handleFetchData()
    }, [isFocused])

    const handleExpireToken = () => {
        setUserData(null)
        setSurveyResponses({})
        LocalStorage.clearAll().then(() => {
            navigation.navigate("Root", { screen: "RegisterLoginStack" })
        })
    }

    const navigateTo = (nextScreen, card) => {
        if (card) {
            let category = categories.filter((item) => item.code === card.code)
            if (category.length > 0) {
                setSelectedKnowledge(category[0].id ?? 1)
                navigation.navigate("Main", {
                    screen: "Knowledge",
                    params: {
                        screen: nextScreen
                    }
                })
            }
        } else {
            navigation.navigate(nextScreen)
        }
    }

    useEffect(() => {
        const unsubscribe = navigation.addListener("focus", () => {})
        // Return the function to unsubscribe from the event so it gets removed on unmount
        return unsubscribe
    }, [navigation])

    const handleDENavigation = () => {
        if (currentEducationalDiagnosis?.diagnosisStatus?.code === DiagnosisState.READY) {
            navigation.navigate("DiagnosticConclusion")
        } else {
            navigateTo("DiagnosticStack")
        }
    }

    useEffect(() => {
        fetchAllAxis({ setLoading, setDiagnosis })
        fetchAllCategories({ setLoading, setCategories })
    }, [])

    const plannifiedStatus = currentEducationalDiagnosis?.visioconference?.id > 0

    const unPlannifiedStatus = {
        title: plannifiedStatus ? "En attente" : "Non planifié",
        descripiton: plannifiedStatus
            ? "Vous avez terminé la première étape du Diagnostic Éducatif. Nous vous invitons à patienter jusqu’à votre entretien."
            : "Veuillez plannifié un Rendez-vous"
    }

    const disableDECard =
        currentEducationalDiagnosis?.diagnosisStatus?.code === DiagnosisState.IN_PREPARATION ||
        (!hasProgramInProgress && currentEducationalDiagnosis === null)

    const isLoading =
        fetchingDiagEduc || fetchingDEFromRQ || loading || fetchingUserPrograms || fetchingPreselectedPatientProgram

    const redirectionFromPushNotification = Notifications.useLastNotificationResponse()

    // useEffect(() => {
    //     console.log({ redirectionFromPushNotificationHome: redirectionFromPushNotification })
    //     if (redirectionFromPushNotification) {
    //         navigation.navigate("FollowUpStack", { screen: "AppointmentHome" })
    //     }
    // }, [redirectionFromPushNotification, isFocused])

    return (
        <View style={styles.container}>
            <NewUpdatePopup />

            <ScrollView
                refreshControl={
                    <RefreshControl
                        refreshing={isLoading}
                        onRefresh={() => {
                            handleFetchData()
                            refetchDE()
                        }}
                    />
                }
                showsVerticalScrollIndicator={false}
                contentContainerStyle={{ paddingBottom: 100 }}
            >
                <CustomSimpleModal open={openFollowUpModal} toggleModal={() => setOpenFollowUPModal(false)}>
                    <BreeSerifText fontSize={24} textAlign={"center"} color={baseColors.black}>
                        La rubrique "Mon suivi" n'est pas encore disponible
                    </BreeSerifText>

                    <Spacer height={10} />

                    <OpenSansText
                        fontSize={16}
                        textAlign={"center"}
                        style={{ marginTop: 10 }}
                        color={baseColors.green.dark}
                    >
                        Pour accéder à cette rubrique, vous devez réaliser votre "Diagnostic Éducatif"
                    </OpenSansText>

                    <Spacer height={10} />

                    <Button
                        roundness={0}
                        width={150}
                        style={{ borderRadius: 5 }}
                        labelColor={baseColors.white}
                        backgroundColor={baseColors.green.primary}
                        text="J'AI COMPRIS"
                        onPress={() => setOpenFollowUPModal(false)}
                    />
                </CustomSimpleModal>

                <View style={styles.content}>
                    <View style={styles.header}>
                        <BreeSerifText style={styles.helloUser} fontSize={24}>
                            Bonjour {user && capitalizeFirstLetter(user?.lastName ?? user?.firstName)} !
                        </BreeSerifText>

                        <OpenSansText defaultFontFamily={baseFontFamily.OpenSansSemiBold} fontSize={16}>
                            Pour accéder à toutes les rubriques, vous devez réaliser votre Diagnostic Éducatif.
                        </OpenSansText>
                    </View>

                    <CardWithoutProgression
                        unPlannifiedStatus={planified ? unPlannifiedStatus : undefined}
                        withStatus={currentEducationalDiagnosis?.diagnosisStatus?.id > 0}
                        disabled={disableDECard}
                        title="Diagnostic Éducatif"
                        currentDiagnoseStatus={currentEducationalDiagnosis?.diagnosisStatus}
                        bgColor={baseColors.green.primary}
                        ellipseColor={baseColors.green.secondary}
                        svgIcon={<SvgStetoscope style={styles.icon} height={RFValue(54)} width={RFValue(54)} />}
                        onPress={() => handleDENavigation()}
                    />

                    <Spacer height={10} />

                    <CardWithoutProgression
                        title="Mon suivi"
                        bgColor={baseColors.orange.primary}
                        ellipseColor={baseColors.orange.secondary}
                        svgIcon={<SvgChecklist style={styles.icon} height={RFValue(54)} width={RFValue(54)} />}
                        onPress={() =>
                            disableMenu
                                ? setOpenFollowUPModal(true)
                                : navigation.navigate("FollowUpStack", {
                                      headerShown: false
                                  })
                        }
                    />

                    <Spacer height={10} />
                    <View style={styles.knowledgeContent}>
                        {isLoading ? (
                            <View style={{ justifyContent: "center", width: "100%" }}>
                                <ActivityIndicator
                                    color={baseColors.green.primary}
                                    size={"large"}
                                    style={{ padding: 30 }}
                                />
                            </View>
                        ) : (
                            knowledges?.map((item, index) => {
                                const marginRight = index !== knowledges.length - 1 ? RFValue(10) : 0
                                return (
                                    <CustomSimpleCard
                                        key={index}
                                        isHomeScreen
                                        disabled={disableMenu}
                                        marginRight={marginRight}
                                        title={item.title}
                                        flexSize={item.flex}
                                        bgColor={item.bgColor}
                                        onPress={() => navigateTo(item.screen, item)}
                                    />
                                )
                            })
                        )}
                    </View>
                </View>
            </ScrollView>
        </View>
    )
}

export default Home
